import { connect } from "react-redux";
import DocumentRegisterBase from "../components/DocumentRegister/DocumentRegisterBase";

const mapStateToProps = (state) => ({
  user: state.login.user,
  menuData: state.menu.menuData,
});

export default connect(mapStateToProps)(DocumentRegisterBase);
